import { useParams } from 'react-router-dom';
import { useCurrentTeam } from '@/providers/TeamProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';

type Props = { children?: React.ReactNode };

export const LoadTeamMember = (props: Props) => {
  const { _w_ } = useCurrentWorkspace();
  const { _t_, me } = useCurrentTeam();
  const { set_w_, set_t_, setMe, setMeTeamMember } = useCurrentTeamMember();
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (_w_ && _t_) {
      set_w_((_) => _w_!);
      set_t_((_) => _t_!);
      setMe((_) => me);
      setMeTeamMember((_) => _t_!.team_members.find((tm) => tm.user.id == me!.id));
      setLoaded(true);
    }
  }, [_w_, _t_]);

  if (loaded) return <>{props.children}</>;

  return <></>;
};
